import SPRAY1 from "../assest/data/SPRAY1.json";
import SPRAY2 from "../assest/data/SPRAY2.json";
import SPRAY3 from "../assest/data/SPRAY3.json";
import SPRAY4 from "../assest/data/SPRAY4.json";
import SPRAY5 from "../assest/data/SPRAY5.json";
import SPRAY6 from "../assest/data/SPRAY6.json";
import SPRAY7 from "../assest/data/SPRAY7.json";
import SPRAY8 from "../assest/data/SPRAY8.json";
import SPRAY9 from "../assest/data/SPRAY9.json";
import SPRAY10 from "../assest/data/SPRAY10.json";
import SPRAY11 from "../assest/data/SPRAY11.json";
import SPRAY12 from "../assest/data/SPRAY12.json";
import SPRAY13 from "../assest/data/SPRAY13.json";
import SPRAY14 from "../assest/data/SPRAY14.json";
import SPRAY15 from "../assest/data/SPRAY15.json";
import SPRAY16 from "../assest/data/SPRAY16.json";
import SPRAY17 from "../assest/data/SPRAY17.json";
import SPRAY18 from "../assest/data/SPRAY18.json";
import SPRAY19 from "../assest/data/SPRAY19.json";
import SPRAY20 from "../assest/data/SPRAY20.json";
import SPRAY21 from "../assest/data/SPRAY21.json";
import SPRAY22 from "../assest/data/SPRAY22.json";
import SPRAY23 from "../assest/data/SPRAY23.json";
import SPRAY24 from "../assest/data/SPRAY24.json";
import SPRAY25 from "../assest/data/SPRAY25.json";
import SPRAY26 from "../assest/data/SPRAY26.json";
import SPRAY27 from "../assest/data/SPRAY27.json";
import SPRAY28 from "../assest/data/SPRAY28.json";
import SPRAY29 from "../assest/data/SPRAY29.json";
import SPRAY30 from "../assest/data/SPRAY30.json";
import SPRAY31 from "../assest/data/SPRAY31.json";
import SPRAY32 from "../assest/data/SPRAY32.json";
import SPRAY33 from "../assest/data/SPRAY33.json";
import SPRAY34 from "../assest/data/SPRAY34.json";
import SPRAY35 from "../assest/data/SPRAY35.json";
import SPRAY36 from "../assest/data/SPRAY36.json";
import ET_FLOW from "../assest/data/ET_FLOW.json";
import ET_TEMP from "../assest/data/ET_TEMP.json";
import dosing_ION from "../assest/data/dosing_ION.json";
import dosing_SG from "../assest/data/dosing_SG.json";
import dosing_ORP from "../assest/data/dosing_ORP.json";
import dosing_TEMP from "../assest/data/dosing_TEMP.json";
import HCl from "../assest/data/HCl.json";

const dataBound = {
  SPRAY1,
  SPRAY2,
  SPRAY3,
  SPRAY4,
  SPRAY5,
  SPRAY6,
  SPRAY7,
  SPRAY8,
  SPRAY9,
  SPRAY10,
  SPRAY11,
  SPRAY12,
  SPRAY13,
  SPRAY14,
  SPRAY15,
  SPRAY16,
  SPRAY17,
  SPRAY18,
  SPRAY19,
  SPRAY20,
  SPRAY21,
  SPRAY22,
  SPRAY23,
  SPRAY24,
  SPRAY25,
  SPRAY26,
  SPRAY27,
  SPRAY28,
  SPRAY29,
  SPRAY30,
  SPRAY31,
  SPRAY32,
  SPRAY33,
  SPRAY34,
  SPRAY35,
  SPRAY36,
  ET_FLOW,
  ET_TEMP,
  dosing_ION,
  dosing_SG,
  dosing_ORP,
  dosing_TEMP,
  HCl,
};
export default dataBound;
